import { ResultsPage } from "./ResultsPage.js";

export default ResultsPage;
